import { useCallback, useState } from "react";
import { Navbar, Nav, NavDropdown, Button } from "react-bootstrap";
import Joint from "../models/joint";
import JointSceneSettings from "../models/joint-scene-settings";

interface JointViewerControlsProps {
    joint: Joint | null;
    initialSettings: JointSceneSettings;
    onSettingsChange(newSettings: JointSceneSettings, oldSettings: JointSceneSettings): void;
}

export default function JointViewerControls({ joint, initialSettings, onSettingsChange }: JointViewerControlsProps) {
    const [settings, setSceneSettings] = useState(initialSettings);

    const applySettings = useCallback((toApply: Partial<JointSceneSettings>) => {
        const prevSettings = settings;
        const newSettings = prevSettings.apply(toApply);
        setSceneSettings(newSettings);

        onSettingsChange(newSettings, prevSettings);
    }, [settings, onSettingsChange]);

    return (
        <div className="jointviewercontrols">
            <Navbar bg="dark" expand="lg" variant="dark">
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Navbar.Brand href="#home">{joint?.reference}</Navbar.Brand>
                    <Nav className="ms-auto">
                        <Nav.Item>
                            <Nav.Link as={Button} variant='link' onClick={() => applySettings({ camera: 'top' })}>Top</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link as={Button} variant='link' onClick={() => applySettings({ camera: 'angled' })}>Angled</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <label>
                                <input type="number"
                                    min={0}
                                    value={settings.axesScale.toString()}
                                    onChange={e => applySettings({ axesScale: Math.max(0, parseInt(e.target.value)) })} />
                                {' '}
                                Axes
                            </label>
                        </Nav.Item>
                        <Nav.Item>
                            <label>
                                <input type="checkbox"
                                    value={settings.debug.toString()}
                                    onChange={() => applySettings({ debug: !settings.debug })}
                                />
                                {' '}
                                Debug
                            </label>
                        </Nav.Item>
                        <Nav.Link as={Button} variant='link' onClick={() => applySettings({ formConnectors: !settings.formConnectors })}>
                            {settings.formConnectors ? 'Flat Connectors' : 'Form Connectors'}
                        </Nav.Link>
                        <Nav.Link as={Button} variant='link' onClick={() => applySettings({ folded: !settings.folded })}>
                            {settings.folded ? 'Unfold' : 'Fold'}
                        </Nav.Link>
                        <NavDropdown title="Viewer Options" id="basic-nav-dropdown">
                            <NavDropdown.Item href="#action/3.1">Show Dimensions</NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.2">Show Labels</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </div>
    );
}
